import React, { useCallback, useEffect, useState } from 'react'
import styles from './CompanyManagementStaffPage.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'
import { TableItem } from '../../types'
import Navbar from '../../components/Navbar/Navbar'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import plusIcon from '../../assets/icons/plus.svg'
import Table from '../../components/Table/Table'
import CustomModal from '../../components/UI/CustomModal/CustomModal'
import CreateStaff from '../../components/CreateStaff/CreateStaff'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useMediaQuery } from 'react-responsive'
import Loader from '../../components/UI/Loader/Loader'
import { getStaff } from '../../redux/actions/staffAction'
import { StaffType } from '../../redux/actions/types'
import { createRoleForTable } from '../../utils/createRoleForRegister'
import { getCurrentCompany } from '../../redux/actions/companiesAction'
import { useRequestStatus } from '../../hooks/useRequestStatus'
import { useDebounce } from '../../hooks/useDebounce'
import { staffPerPage } from '../../constants/constants'
import ProfileCategories from '../../components/ProfileCategories/ProfileCategories'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'

const CompanyManagementStaffPage = () => {
  const [search, setSearch] = useState<string>('')
  const [modal, setModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [staffStatus, setStaffStatus] = useState<any>('')

  const debouncedStatus = useRequestStatus(staffStatus)
  const debounced = useDebounce(search, 1000)

  const { currentCompany } = useAppSelector((state) => state.companies)
  const { token, user, userRole } = useAppSelector((state) => state.auth)

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  const { isLoading, staff } = useAppSelector((state) => state.staff)

  const { companyId } = useParams<{ companyId: string }>()

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const { meData } = useAppSelector((state) => state.me)
  const onRedirectToCompanyManagementStaffPage = () => {
    navigate(-1)
  }

  const onActiveCurrentCompanyCard = (id: number) => {
    navigate(`${PATH.companyStaffCardPage}${companyId}/${id}`)
  }

  const handleButtonClick = useCallback(
    async (btnTitle: string) => {
      if (btnTitle === 'Все') {
        setStaffStatus('')
        setCurrentPage(1)
        return
      }
      if (btnTitle === 'Агент') {
        setStaffStatus('employeeAgent')
        setCurrentPage(1)
        return
      }
      if (btnTitle === 'Зал') {
        setStaffStatus('employeePlace')
        setCurrentPage(1)
        return
      }
      if (btnTitle === 'Директор-Зал') {
        setStaffStatus('directorPlace')
        setCurrentPage(1)
        return
      }
      if (btnTitle === 'Директор-Агент') {
        setStaffStatus('directorAgent')
        setCurrentPage(1)
        return
      }
    },
    [debouncedStatus],
  )

  const dummyData = (array: StaffType[]) => {
    const items: TableItem[] = array.map((staff) => {
      return {
        id: staff?.id,
        firstColumn: staff?.company?.name,
        secondColumn: staff?.user?.fullName,
        thirdColumn: staff?.user?.phone,
        fourthColumn: staff?.user?.email,
        fifthColumn: createRoleForTable(staff?.user?.role),
      }
    })
    return items
  }

  useEffect(() => {
    if (debounced) {
      dispatch(
        getStaff({
          companyId,
          token,
          page: 1,
          itemsPerPage: staffPerPage,
          role: debouncedStatus,
          search: debounced,
        }),
      )
    } else {
      dispatch(
        getStaff({
          companyId,
          token,
          page: currentPage,
          itemsPerPage: staffPerPage,
          role: debouncedStatus,
        }),
      )
    }
  }, [dispatch, companyId, currentPage, setCurrentPage, staffPerPage, debounced, debouncedStatus])

  useEffect(() => {
    dispatch(getCurrentCompany({ companyId, token }))
  }, [companyId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.companyStaff}>
      <Navbar />
      <HeaderForCard
        title={`${meData.user.fullName}`}
        onRedirectHandler={onRedirectToCompanyManagementStaffPage}
      />

      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.categoriesBlock}>
            <ProfileCategories
              categories={[
                { id: 1, title: 'Основная информация' },
                { id: 2, title: 'Сотрудники компании' },
              ]}
              activeLink={2}
              cardId={String(currentCompany.id)}
            />
          </div>
        </div>
      </div>

      <Table
        customButton={
          userRole !== 'employeeAgent' && userRole !== 'employeePlace' ? (
            <CustomButton
              iconSrc={isMobile ? plusIcon : ''}
              className={styles.addSiteBtn}
              title={isMobile ? '' : 'Создать сотрудника'}
              type='button'
              onClick={() => setModal(true)}
            />
          ) : (
            <></>
          )
        }
        isLoading={isLoading}
        data={dummyData(staff.employees)}
        pageSize={staffPerPage}
        totalCountPages={staff.totalCount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        columns={['Компания', 'ФИО', 'Номер телефона', 'Электронная почта', 'Роль']}
        filtersTitles={
          currentCompany.role === 'directorAgent'
            ? {
                firstBtnTitle: 'Все',
                secondBtnTitle: 'Агент',
                thirdBtnTitle: 'Директор-Агент',
              }
            : {
                firstBtnTitle: 'Все',
                secondBtnTitle: 'Зал',
                thirdBtnTitle: 'Директор-Зал',
              }
        }
        onActiveCurrentCard={onActiveCurrentCompanyCard}
        handleFirstFilterButtonClick={handleButtonClick}
        handleSecondFilterButtonClick={handleButtonClick}
        handleThirdFilterButtonClick={handleButtonClick}
        handleFourthFilterButtonClick={handleButtonClick}
        search={search}
        setSearch={setSearch}
        debouncedStatus={debouncedStatus}
      />
      {/* <Footer /> */}
      <CustomModal visible={modal} setVisible={setModal}>
        <CreateStaff onClickHandler={() => setModal(false)} />
      </CustomModal>
    </div>
  )
}

export default CompanyManagementStaffPage
